<template>
  <section class="l-content">
    <el-card>
      <el-form :inline="true" :model="condition">
        <el-form-item>
          <el-input v-model="condition.keyword" placeholder="地点名称/区域" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider></el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="is_enabled" slot-scope="scope">
          <el-tag :type="scope.row.is_enabled ? 'success' : 'danger'">
            {{ scope.row.is_enabled ? '启用' : '禁用' }}
          </el-tag>
        </template>
        <template slot="qrcode" slot-scope="scope">
          <el-image v-if="scope.row.qrcode_url" :src="scope.row.qrcode_url" fit="contain" style="width: 60px; height: 60px;"
            @click="previewQrcode(scope.row)"></el-image>
          <span v-else>未生成</span>
        </template>
      </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import locationEdit from './locationEdit.vue'

export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'CleanLocationList',
  data() {
    return {
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index', width: 60 },
          { label: '地点名称', prop: 'location_name', width: 180 },
          { label: '所属区域', prop: 'area', width: 120 },
          { label: '保洁周期(天)', prop: 'clean_cycle', width: 120 },
          { label: '二维码', slot: 'qrcode', width: 100 },
          { label: '状态', slot: 'is_enabled', width: 80 },
          { label: '创建时间', prop: 'create_time', width: 160 },
          { label: '备注', prop: 'remark' }
        ],
        operation: {
          width: '380',
          header: { type: 'primary', icon: 'el-icon-plus', label: '新增地点', click: this.add },
          buttons: [
            { type: 'primary', icon: 'el-icon-edit', label: '修改', click: this.edit },
            { type: 'success', icon: 'el-icon-picture', label: '查看二维码', click: this.viewQrcode },
            { type: 'danger', icon: 'el-icon-delete', label: '删除', click: this.del }
          ]
        }
      },
      condition: {
        keyword: '',
        pageIndex: 1,
        pageSize: 15
      },
      pageData: null,
      qrcodeDialogVisible: false,
      currentQrcode: ''
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/clean/location/page', {
        enterpriseCode: this.userInfo.enterpriseCode,
        keyword: this.condition.keyword,
        pageIndex: this.condition.pageIndex,
        pageSize: this.condition.pageSize
      })
    },
    async add() {
      const dataInfo = {
        location_id: 0,
        enterprise_code: this.userInfo.enterpriseCode,
        create_user_id: this.userInfo.userId,
        create_user_name: this.userInfo.fullName,
        clean_cycle: 1,
        is_enabled: true
      }
      await this.$lgh.openDialog({
        ins: locationEdit,
        title: '新增保洁地点',
        data: {
          isAdd: true,
          dataInfo: dataInfo
        }
      })
      this.$lgh.notifySuccess('新增成功', '新增保洁地点成功')
      this.getPageData()
    },
    async edit(item) {
      await this.$lgh.openDialog({
        ins: locationEdit,
        title: '修改保洁地点',
        data: {
          isAdd: false,
          dataInfo: Object.assign({}, item)
        }
      })
      this.$lgh.notifySuccess('修改成功', '修改保洁地点成功')
      this.getPageData()
    },
    viewQrcode(item) {
      if (item.qrcode_url) {
        this.currentQrcode = item.qrcode_url
        this.qrcodeDialogVisible = true
      } else {
        this.$lgh.notifyWarning('该地点还未生成二维码')
      }
    },
    previewQrcode(item) {
      this.viewQrcode(item)
    },
    del(item) {
      this.$lgh.msgConfirm('确认删除该地点?', async () => {
        await this.$lgh.get('api/clean/location/delete', { locationId: item.location_id })
        this.$lgh.notifySuccess('删除成功', '删除保洁地点成功')
        this.getPageData()
      })
    }
  }
}
</script>
